import { Download } from "lucide-react";

import { CATALOG_PDF_PATH } from "@/lib/constants";

import { Button } from "../ui/button";

export default function CatalogButton ({
  href = CATALOG_PDF_PATH,
  fileName = "catalog.pdf",
}) {
    return (
        <a href={href} download={fileName}>
            <Button variant="berryBorder" size="xl">
              دانلود کاتالوگ
              <Download size={24} />
            </Button>
        </a>
    )
}